import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  removeProjectStatus(
    request: Boundaries["removeProjectStatus"]["request"],
  ): void;
}

function useRemoveProjectStatus(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(selector.isRemoveProjectStatusRequestPending),
    isRequestSuccess: useSelector(selector.isRemoveProjectStatusRequestSuccess),
    isRequestFailure: useSelector(selector.isRemoveProjectStatusRequestFailure),
    removeProjectStatus: core.removeProjectStatus,
  };
}

export { useRemoveProjectStatus };
